import { GraphQLClient } from 'graphql-request';
import { v4 as uuid } from 'uuid';

const endpoint = process.env.NEXT_PUBLIC_GQL_ENDPOINT;
const apiKey = process.env.NEXT_PUBLIC_GQL_API_KEY;

const client = new GraphQLClient(`${endpoint}`, {
  headers: {
    authorization: apiKey,
    'X-Request-ID': uuid(),
  },
});

export default client;
